module.exports = __webpack_public_path__ + "downloads/Post_Graduate_Sample.1acc0bbe.xlsx";